module.exports = __webpack_public_path__ + "static/PrimitiveTwo-adf1547d08d57e3fbb3d272f60c2edb3.png";